module.exports = __webpack_public_path__ + "static/media/IMG_9401.78ed24de.JPG";